import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogTitle, 
  ogDescription, 
  ogImage, 
  ogType = 'website',
  twitterCard = 'summary_large_image',
  structuredData 
}) => {
  const defaultTitle = 'AI Receptionist for Your Business | Receptioneer.ai';
  const defaultDescription = 'Never miss a customer call again. Our AI receptionist answers calls, books appointments, and handles inquiries 24/7 for your business.';
  const defaultKeywords = 'AI receptionist, virtual receptionist, automated phone system, business phone service, appointment booking, customer service automation';
  const defaultOgImage = 'https://receptioneer.ai/images/og-image.jpg';
  const siteUrl = 'https://receptioneer.ai';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="author" content="Receptioneer.ai" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical || siteUrl} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={ogTitle || title || defaultTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Receptioneer.ai" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={ogTitle || title || defaultTitle} />
      <meta name="twitter:description" content={ogDescription || description || defaultDescription} />
      <meta name="twitter:image" content={ogImage || defaultOgImage} />
      
      {/* LinkedIn specific */}
      <meta property="article:author" content="Receptioneer.ai" />
      <meta property="og:locale" content="en_US" />
      
      {/* Additional SEO Tags */}
      <meta name="theme-color" content="#1e40af" />
      <meta name="msapplication-TileColor" content="#1e40af" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;